import { createAction, props } from '@ngrx/store';

/**
 * sets screen size
 */
export const setLanguage = createAction(
  '[Global] Set Lang',
  props<{ lang: any }>()
);
